module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<option value=\'' +
((__t = (name )) == null ? '' : __t) +
'\'>' +
((__t = (name )) == null ? '' : __t) +
'</option>';

}
return __p
}